import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isEqual } from 'lodash-es';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import { CTA_TYPE } from 'site-modules/shared/constants/inventory/lead-form';
import { EmbeddedLeadForm } from 'site-modules/shared/components/lead-form/unified-lead-form-pages/embedded-lead-form';

const EMBEDDED_LEAD_FORM_MAP = [CTA_TYPE.NEW.BASE, CTA_TYPE.USED.BASE];

export const getEmbeddedLeadFormCta = ctas => ctas.find(cta => EMBEDDED_LEAD_FORM_MAP.includes(cta));

function VDPEmbeddedLeadFormComponent({
  ctas = [],
  params,
  pathname,
  daysToSell = null,
  hideContactDealerTip = false,
  className = '',
  styles = {},
}) {
  const unifiedLeadFormCTA = getEmbeddedLeadFormCta(ctas);
  const shop5146Recipe = useSelector(state =>
    ExperimentUtil.getForcedOrAssignedRecipeName({
      state,
      campaignName: 'shop-5146-nci-copy',
      defaultVal: 'ctrl',
    })
  );
  const isShop5146NciChallenge = params?.isNewVin && shop5146Recipe === 'chal';

  if (!unifiedLeadFormCTA) {
    return null;
  }

  return (
    <EmbeddedLeadForm
      params={params}
      options={{
        pathname,
        unifiedLeadFormCTA,
        daysToSell,
        hideContactDealerTip,
      }}
      styles={styles}
      className={className}
      isVdp
      isShop5146NciChallenge={isShop5146NciChallenge}
    />
  );
}

VDPEmbeddedLeadFormComponent.propTypes = {
  ctas: PropTypes.arrayOf(PropTypes.string),
  params: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.number,
    zipCode: PropTypes.string,
    radius: PropTypes.number,
    vin: PropTypes.string,
    submodel: PropTypes.string,
    submodelIdentifier: PropTypes.string,
    isNewVin: PropTypes.bool,
  }).isRequired,
  pathname: PropTypes.string.isRequired,
  daysToSell: PropTypes.number,
  hideContactDealerTip: PropTypes.bool,
  className: PropTypes.string,
  styles: PropTypes.shape({}),
};

export const propsAreEqual = (propsPrev, propsNext) => isEqual(propsPrev, propsNext);
export const VDPEmbeddedLeadForm = memo(VDPEmbeddedLeadFormComponent, propsAreEqual);
